import React, { useEffect, useState }  from 'react';
import LoggingTamplate from '../../../template/Logging/LoggingTamplate';

const LogingComponent = () => {
    const [activeTab, setActiveTab] = useState('All')
    const [tabsNotif, setTabsNotif] = useState([
        'All',
        'Dashboard',
        'Moderation',
        'Security',
        'Verification',
        'Errors'
    ])
    const [logArr, setLogArr] = useState([
        {
            colorNotif:'pink',
            img:'/img/notif_img/user2.png',
            name:'Koi',
            id:'#200',
            event: 'enabled Anti-DM',
            date:'Today at 20:24'
        },
        {
            colorNotif:'turquoise',
            img:'/img/notif_img/bot.png',
            name:'Themis',
            id:'#8687',
            event: 'banned FreeMoney#1284',
            date:'Today at 20:14'
        },
        {
            colorNotif:'pink',
            img:'/img/notif_img/meow.png',
            name:'Meow',
            id:'#8687',
            event: 'added Kotoro#9999 to Bot Masters',
            date:'Today at 19:53'
        },
        {
            colorNotif:'turquoise',
            img:'/img/notif_img/bot.png',
            name:'Themis',
            id:'#8687',
            event: 'banned Azuki_Airdrop#8317',
            date:'Yesrday at 11:35'
        },
    ])

    return (
        <div className='setting_component_wrap logging_component_wrap'>
            <div className='overview_component_content_head'>
                    <h4>Themis and Dashboard Global Settings</h4>
                    <p>Get a summary of your server's security, including details on detected threats, recent moderation actions, and user activity.</p>
            </div>
            <div className='' style={{width:'100%'}}>
                <LoggingTamplate
                date={logArr}
                tabsNotif={tabsNotif}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                />
            </div>
        </div>
    );
};

export default LogingComponent;